import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { baseUrl, apiHelper } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import ColumnBox from 'components/ColumnBox';
import RowBox from 'components/RowBox';
import SmallHeading from 'components/SmallHeading';
import folkLogo from 'images/folklogo.png';

export default function Form(props) {
    const [ currentTrip, setCurrentTrip ] = useState(null);
    const [ availableTrips, setAvailableTrips ] = useState([]);
    const qIndex = useRef(0);
    const [ currentFormResponse, setCurrentFormResponse ] = useState({});
    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const [ isFullScreen, setIsFullScreen ] = useState(false);
    const [ shouldShowSubmitScreen, setShouldShowSubmitScreen ] = useState(false);

    const refreshData = function() {
        qIndex.current = 0;

        let apiUrl = `${baseUrl}/api/prasadam_feedback`;
        let apiPromise = apiHelper.get({ "url": apiUrl })
        apiPromise
        .then(response => {
            if (response.status) {
                setAvailableTrips(response.json.feedback_questions || []);
                if (response.json.feedback_questions &&
                    response.json.feedback_questions.length > 0) {
                    setCurrentTrip(response.json.feedback_questions[0]);
                }
            } else {
                console.log(response.json);
                // toastr.error("Unable to fetch available Trips. Please try again later");
            }
        })
    }

    const jumpToNext = function(question, answer) {
        setCurrentFormResponse({ ...currentFormResponse, [question]: answer })
        const elem = document.getElementById('feedback-showcase');
        elem.style.opacity = '0.5';
        qIndex.current = qIndex.current + 1;
        if (qIndex.current < availableTrips.length) {
            setCurrentTrip(availableTrips[qIndex.current]);
        } else {
            setCurrentTrip(null);
            setShouldShowSubmitScreen(true);
            saveFeedback({ ...currentFormResponse, [question]: answer });
        }
        setTimeout(function() {
            elem.style.opacity = '1';
        }, 500);
    }
    
    const saveFeedback = (payloadData) => {
        setIsSubmitting(true);

        let apiUrl = `${baseUrl}/api/prasadam_feedback`;
        let apiPromise = apiHelper.post({ "url": apiUrl, "data": payloadData })
        apiPromise
        .then(response => {
            if (response.status) {
                notify.success({ "description": "Feedback submitted. Thank you for taking out time to fill it 😊" });
                cancelSubmission();
            } else {
                console.log(response.json);
                notify.error({ "description": "Unable to save feedback... Please check internet connection" });
            }
            setIsSubmitting(false);
        })
    };
    const cancelSubmission = () => {
        setCurrentFormResponse({});
        setShouldShowSubmitScreen(false);
        if (availableTrips.length > 0) {
            qIndex.current = 0;
            setCurrentTrip(availableTrips[qIndex.current]);
        }
    };
    const goFullScreen = function() {
        const elem = document.querySelector('body');
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
            elem.msRequestFullscreen();
        }
        setIsFullScreen(true);
    }
    
    useEffect(() => {
        refreshData()
    }, [])

    return (
        <Box sx={{ backgroundColor: 'azure', minHeight: '100vh' }}>
            <Box sx={{ transition: 'opacity 0.25s' }} id="feedback-showcase">
                <Box sx={{ textAlign: 'center' }}>
                    <img style={{ height: '15vh' }} src={folkLogo} alt="FOLK Logo" />
                </Box>
                <ColumnBox sx={{ alignItems: 'center', height: '70vh', padding: '5px',
                    justifyContent: 'space-around' }}>
                    { currentTrip &&
                    <>
                        <Box sx={{ fontSize: '25px', color: 'teal', marginTop: '20px',
                            marginBottom: '15px', fontWeight: 600, textAlign: 'center',
                            whiteSpace: 'pre-wrap' }}>
                            {currentTrip["Question Title"]}
                        </Box>
                        <RowBox sx={{ width: '100%', width: '100vw', maxWidth: '1000px',
                            justifyContent: 'space-around' }}>
                            { currentTrip["Options"].map(opt => (
                                <img onClick={() => jumpToNext(currentTrip["Question Title"], opt)}
                                    style={{ width: '25vw', height: '25vw' }} key={opt}
                                    src={require(`images/${opt.toLowerCase()}.png`)}></img>
                            )) }
                        </RowBox>
                    </> }
                    { shouldShowSubmitScreen &&
                        <>
                        { isSubmitting &&
                        <span style={{ fontSize: '25px' }} className="loader-icon">⚙️</span>
                        }
                        </>
                    }
                </ColumnBox>
            </Box>
            { !isFullScreen && <Box sx={{ textAlign: 'center' }}>
                <Button sx={{ fontSize: '20px'}} variant="outlined"
                    onClick={goFullScreen}>
                    Go Full Screen</Button>
            </Box> }
        </Box>
    );
}
